/**
 * External Imports
 */
import styled from 'styled-components';

export const SubToolbar = styled.div`
  display: flex;
  position: relative;
  height: 95px;
  width: 100%;
  background: white;
  font-weight: 700;
  padding-left: 0;
  padding-right: 0.5rem;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  z-index: 6;
`;

export const AccountHeader = styled.span`
  position: absolute;
  color: #093865;
  font-size: 1rem;
  padding: 8px 5px 4px 1em;
  display: flex;
  flex: 1;
`;

export const AccountInfoContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 2.5em;
  padding-top: 2.25em;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 3.5em;
  left: 0;
  top: 0;
  padding-right: 1em;
  padding-left: 1em;
  color: #4b4b4b;
  font-size: 14;
  line-height: 22px;
  font-style: normal;
  font-weight: 700;
  // & span:nth-child(1) {
  //   flex-basis: 22%;
  // }
  // & span:nth-child(2) {
  //   flex-basis: 22%;
  // }
  // & span:not(:first-child) {
  //   margin: 0px 1em;
  // }
`;

export const Avatar = styled.div`
  margin-left: 10px !important;
`;

export const UserInfo = styled.span`
  white-space: pre;
  font-weight: normal;
  font-weight: 400;
  color: #686868;
  display: block;
`;

export const HeaderTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #4b4b4b;
  text-wrap: nowrap;
`;

export const UserAvatar = styled.div`
  height: 50px;
  width: 50px;
`;

export const EditButton = styled.button`
  background: transparent;
  color: var(--primary-60);
  font-size: 0.85rem;
  font-weight: 700;
  width: fit-content;
`;

export const EditContainer = styled.div`
  margin-left: 25px;
  padding: 0.3rem 0;
`;
